
class CustomerServiceSerializer {
  static deSerialize(data) {
    return {
      serviceId: data.ServicioID,
      cardId: data.Documento,
    };
  }
}

export { CustomerServiceSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/CustomerServiceSerializer.js